var _path, _path2, _path3, _line, _g, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _line2, _g3, _path12, _path13, _g4, _path14, _path15, _path16, _path17, _g5, _g6, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBhimarathashanthi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "  M40.815,61.358C50,63.875,51.652,75.859,51.652,75.859"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "  M8.825,84.538v-5.457c0-7.453,3.9-13.994,9.771-17.695"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M45.417,44.573v5.666  c0,8.686-7.042,15.728-15.728,15.728l0,0c-8.686,0-15.727-7.042-15.727-15.728v-5.666"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 25.105,
    y1: 41.796,
    x2: 34.19,
    y2: 41.796
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 36.386,
    cy: 48.2,
    r: 2.085
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.908,
    cy: 48.2,
    r: 2.085
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M32.951,56.54  c-0.444,1.035-1.479,2.07-3.304,2.07c-1.825,0-2.961-1.035-3.304-2.07"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M17.352,48.998   L17.352,48.998c0,1.753,1.422,3.175,3.176,3.175h4.027c1.754,0,3.174-1.422,3.174-3.175l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M42.028,49.047   L42.028,49.047c0,1.753-1.422,3.175-3.176,3.175h-4.027c-1.754,0-3.175-1.422-3.175-3.175l0,0"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 27.729,
    y1: 48.998,
    x2: 31.65,
    y2: 48.998
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "  M30.159,47.149c0,0-1.508,2.392-1.508,6.273h2.713"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M10.678,50.854v-6.896  c0-10.571,8.569-19.14,19.14-19.14l0,0c10.571,0,19.141,8.568,19.141,19.14v6.896"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "  M25.559,34.2c0,0,0.434,5.461-5.386,5.387c0,0-1.368,4.986-6.21,4.986"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "  M33.451,34.2c0,0-0.434,5.461,5.386,5.387c0,0,1.369,4.986,6.211,4.986"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M48.958,51.148  c2.848,0,5.159,2.312,5.159,5.161s-2.311,5.16-5.159,5.16"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M10.678,51.148  c-2.85,0-5.16,2.312-5.16,5.161s2.311,5.16,5.16,5.16"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M89.127,45.312  c0,8.756-7.098,15.467-15.852,15.467l0,0c-8.756,0-15.854-6.711-15.854-15.467"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "  M84.549,56.644c5.889,3.708,9.795,10.271,9.779,17.744l-0.012,10.15"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "  M51.652,75.859c0,0,0.598-15.081,10.68-19.247"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 70.074,
    y1: 36.122,
    x2: 76.979,
    y2: 36.122
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 80.12,
    cy: 42.525,
    r: 2.085
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.643,
    cy: 42.525,
    r: 2.086
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M76.686,51.325  c-0.445,1.035-1.479,2.07-3.305,2.07c-1.824,0-2.961-1.035-3.303-2.07"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "  M73.869,41.591c0,0-1.508,2.393-1.508,6.273h2.715"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M68.07,46.241   c0,0-1.635,0.441-2.34,1.352"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M78.689,46.2    c0,0,1.635,0.441,2.342,1.352"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M92.418,38.51"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M54.08,38.51"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "  M57.422,45.312L57.422,45.312c1.846,0,3.342-1.496,3.342-3.342V31.079c0,0,4.084-4.795,12.512-4.795  c6.139,0,12.459,3.16,12.459,4.795V41.97c0,1.846,1.496,3.342,3.342,3.342l0,0c0,0-0.115-6.613,3.34-6.613l0,0  c0-10.57-8.57-17.973-19.141-17.973l0,0c-10.572,0-19.141,6.787-19.141,17.357v0.615"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "  M57.422,45.312c0,0,0-6.613-3.287-6.613"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "   M52.852,41.11v4.318c0,1.61,1.307,2.916,2.916,2.916l0,0"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 57.074,
    y1: 48.345,
    x2: 55.768,
    y2: 48.345
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "   M93.35,41.11v4.318c0,1.61-1.305,2.916-2.916,2.916l0,0"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 90.434,
    y1: 48.345,
    x2: 89.127,
    y2: 48.345
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 70.074,
    y1: 32.64,
    x2: 76.979,
    y2: 32.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhimarathashanthi);
export default __webpack_public_path__ + "static/media/Bhimaratha shanthi.a0c616e84ae2424a981918f6f705f0e0.svg";
export { ForwardRef as ReactComponent };